
    export function _add_styles_to_shadow(shadow, styles) {
        shadow.adoptedStyleSheets = [...shadow.adoptedStyleSheets, styles];
    }
